import axios from 'axios';
import Promise from 'promise';
import config from './environmentConfig';
import { toast } from 'react-toastify';
import { t } from 'i18next';
import { COMMON_HTTP_I18N_KEYS, COMMON_HTTP_I18N_PREFIX, } from './i18n/Commoni18nConstants';
const env = process.env.NODE_ENV || 'development';
const http = axios.create({
  baseURL: config[env].BASE_URL,
});

http.interceptors.request.use(
  function(config) {
    return config;
  },
  function(error) {
    return Promise.resolve({ error });
  },
);
http.interceptors.response.use(
  response => {
    return response;
  },
  err => {
    return new Promise(function(resolve, reject) {
      if (err.response && err.response.status === 401) {
        toast.error(t(COMMON_HTTP_I18N_PREFIX + "." + COMMON_HTTP_I18N_KEYS.authentication_failed_or_expired));
      }
      throw err;
    });
  },
);

http.defaults.withCredentials = true;

export default http;



// WEBPACK FOOTER //
// ./src/common/http.js